<template>
  <div class="container header-nav" :class="{ fixed: fixed }">
    <div class="content">
      <div class="top-bar">
        <span class="font-color-1">
          <span class="font-size-14">业务合作：</span> 13087507717
          <span class="font-size-14">客服专线：</span> 18729372124
        </span>
        <button @click="register()">
          <a href class="font-color-1">企业注册</a>
        </button>
        <button @click="login()">
          <a href class="font-color-1">{{text}}</a>
        </button>
      </div>
      <div class="logo-warp">
        <img
          class="logo"
          :src="
            fixed
              ? 'https://file.lgbfss.com/www/official/images/logo1.png'
              : 'https://file.lgbfss.com/www/official/images/logo.png'
          "
          alt
        />
      </div>
      <div class="row nav">
        <div class="nav-item">
          <!-- @mouseenter="navHover('index')" @mouseleave="clearHover()" -->
          <h5>
            <a href="/website/?id=1" :class="{ active: activeIndex === 1 }">首页</a>
          </h5>
          <!-- <ul class="sub-nav animate__animated">
            <li>公司介绍</li>
            <li>联系我们</li>
          </ul>-->
        </div>
        <!-- <div>
          <h5>
            <a href="/website/market?id=2" :class="{ active: activeIndex === 2 }">市场信息</a>
          </h5>
        </div>-->
        <div>
          <h5>
            <a href="/website/maker?id=3" :class="{ active: activeIndex === 3 }">放薪管家</a>
          </h5>
        </div>
        <div>
          <h5>
            <a href="/website/out_source?id=4" :class="{ active: activeIndex === 4 }">金创客</a>
          </h5>
        </div>
        <!-- <div>
          <h5>
            <a href="">零工外包/内容待定</a>
          </h5>
        </div>-->
        <!-- <div>
          <h5>
            <a href="/website/education?id=5" :class="{ active: activeIndex === 5 }"
              >零工教育</a
            >
          </h5>
        </div>-->
        <div>
          <h5>
            <a href="/website/news?id=6" :class="{ active: activeIndex === 6 }">大事记</a>
          </h5>
        </div>
        <div class="nav-item">
          <h5>
            <a href="/website/about_us?tab=4&id=7" :class="{ active: activeIndex === 7 }">关于我们</a>
          </h5>
          <ul class="sub-nav">
            <li>
              <a href="/website/about_us?tab=0">公司介绍</a>
            </li>
            <li>
              <a href="/website/about_us?tab=3">联系我们</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String
  },
  data: () => {
    return {
      fixed: false,
      activeIndex: 1,
      text: "登录"
    };
  },
  created () {
    if (localStorage.getItem("token")) {
      this.text = "控制台"
    } else {
      this.text = "登录"
    }
    const id = this.$route.query.id;
    this.activeIndex = Number(id)
  },
  mounted: function () {
    if (this.message) {
      this.fixed = true
    } else {
      window.addEventListener("scroll", () => {
        this.fixed = window.scrollY > 0;
      });
    }

  },
  methods: {
    login () {
      window.open('/web/login')
    },
    register () {
      window.open('/web/register')
    }
  }
};
</script>

<style lang="css" scoped>
.top-bar {
  text-align: right;
  margin-top: 20px;
}
.top-bar button {
  margin-left: 20px;
}
.logo-warp {
  position: absolute;
  margin-top: -10px;
}
.logo {
  width: 200px;
}
button {
  background: transparent;
  border: 1px solid #fff;
  border-radius: 4px;
  padding: 2px 10px;
  color: #fff;
}
button:hover {
  background: #5fccff;
  cursor: pointer;
  border-color: #5fccff;
}
.nav {
  margin-top: 29px;
  margin-left: 420px;
  justify-content: space-between !important;
}
.nav a {
  color: #fff;
  transition: color 0.2s;
}
.nav a:hover {
  color: #5fccff !important;
}
.nav a.active {
  color: #5fccff !important;
}
.sub-nav {
  overflow: hidden;
  color: #fff;
  font-size: 13px;
  text-align: center;
  border-radius: 2px;
  min-width: 100px;
  position: absolute;
  padding-top: 13px;
  display: none;
}
.nav-item:hover .sub-nav {
  display: block;
}
.sub-nav li {
  margin-top: 1px;
  line-height: 32px;
  background: #a7a5aa;
  opacity: 0.8;
  cursor: pointer;
}
.sub-nav li:first-child {
  margin-top: 0px;
}
.header-nav {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  padding-bottom: 13px;
}
.fixed {
  position: fixed;
  background: #fff;
  animation: change 1s;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
}
.fixed .nav a,
.fixed .font-color-1 {
  color: #888;
}
.fixed button {
  color: #888;
  border-color: #888;
}

@keyframes change {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>